import React, { useState } from 'react';
import Card from 'components/card';
import CustomDropdown from 'components/dropdown/CustomDropdown';
import InputField from 'components/fields/InputField';
import { createData } from '../../../../services/ApiFetching';
import { FaArrowLeftLong } from "react-icons/fa6";
import { useEffect } from 'react';
import { fetchData, updateData } from '../../../../services/ApiFetching';
import { createCustomer } from '../../../../services/ApiLogin';
import toast from "react-hot-toast";

const UserCreation = ({ setCreateUser, userId, setCreateCustomer }) => {
    const token = localStorage.getItem('token');

    const roles = token ? [
        { label: "Admin", value: "admin" },
        { label: "Agent", value: "agent" },
        { label: "Customer", value: "customer" }
    ] : [{ label: "Customer", value: "customer" },];

    const statuses = token ? [
        { label: "Active", value: "active" },
        { label: "In Active", value: "inactive" },
    ] : [{ label: "In Active", value: "inactive" }];

    const [formData, setFormData] = useState({
        username: '',
        role: '',
        status: '',
        email: '',
        newPassword: '',
    });

    const handleChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
    };

    const handleChangePassword = async () => {
        if (!formData.newPassword) {
            alert("Please enter a new password.");
            return;
        }
        try {
            await updateData("users/changepassword", formData);
            alert("Password updated successfully!");
            setFormData(prev => ({ ...prev, newPassword: '' }));
        } catch (err) {
            alert("Error: " + err.message);
        }
    };

    const handleSubmit = async () => {
        if (!formData.username) {
            toast.error("Please enter a user name.");
            return;
        }
        if (!formData.email) {
            toast.error("Please enter a email.");
            return;
        }
        if (!formData.role) {
            toast.error("Please enter a role.");
            return;
        }
        if (!formData.status) {
            toast.error("Please enter a status.");
            return;
        }
        try {
            if (token) {
                if (userId) {
                    await updateData(`users/${userId}`, formData);
                    toast.success("User Updated Successfully!");
                } else {
                    if (!formData.newPassword) {
                        toast.error("Please enter a password.");
                        return;
                    }
                    await createData('users', formData);
                    toast.success("User Created Successfully!");
                    setFormData({ username: '', role: '', status: '', email: '', newPassword: '' });
                }
            } else {
                if (!formData.newPassword) {
                    toast.error("Please enter a password.");
                    return;
                }
                await createCustomer(`auth/createAccount`, formData);
                toast.success("User Created Successfully!");
            }
            
        } catch (err) {
            toast.error(`User ${userId ? 'Update' : 'Creation'} Failed: ` + err.message);
        }
    };

    useEffect(() => {
        const fetchUser = async () => {
            if (userId) {
                try {
                    const user = await fetchData(`users/${userId}`);
                    setFormData({
                        username: user.username || '',
                        role: user.role || '',
                        status: user.status || '',
                        email: user.email || '',
                        newPassword: '',
                    });
                } catch (err) {
                    alert("Failed to fetch user: " + err.message);
                }
            } else if(!token) {
                setFormData({
                    username: '',
                    role: 'customer',
                    status: 'inactive',
                    email: '',
                    newPassword: '',
                });
            } else {
                setFormData({
                    username: '',
                    role: 'agent',
                    status: 'active',
                    email: '',
                    newPassword: '',
                });
            }
        };

        fetchUser();
    }, [userId]);

    return (
        <Card className={`h-full bg-white rounded-xl ${token ? 'p-4' : ""}`}>
            <div className="flex items-center mb-3">
                <div onClick={() => setCreateUser?.(false) || setCreateCustomer?.(false)} className="mr-3 cursor-pointer"><FaArrowLeftLong /></div>
                <div className="text-xl font-bold text-navy-700 dark:text-white">
                    {token ? <>
                    {userId ? 'EDIT USER' : 'CREATE USER'}
                    
                    </> : <>
                    CREATE ACCOUNT
                    </>}
                    </div>
            </div>
            <InputField
                variant="auth"
                extra="mb-3"
                label="Name*"
                placeholder="Full Name"
                id="username"
                type="text"
                autoComplete="name"
                value={formData.username}
                onChange={(e) => handleChange("username", e.target.value)}
            />
            <InputField
                variant="auth"
                extra="mb-3"
                label="Email*"
                placeholder="user@mail.com"
                id="email"
                type="text"
                autoComplete="email"
                value={formData.email}
                onChange={(e) => handleChange("email", e.target.value)}
            />
            <div className='flex justify-between gap-3'>
                <InputField
                    variant="auth"
                    extra="mb-3 w-[100%]"
                    label={userId ? "Change Password*" : "Password*"}
                    placeholder={userId ? "Enter Your New Password, If You Want To Change" : "Enter Your Password"}
                    id="newPassword"
                    type="password"
                    autoComplete="off"
                    value={formData.newPassword}
                    onChange={(e) => handleChange("newPassword", e.target.value)}
                />
                {userId && (
                    <button
                        onClick={handleChangePassword}
                        className="w-[100%] mt-8 h-full p-3 bg-brand-500 text-white rounded-md hover:bg-brand-700"
                    >
                        Change Password
                    </button>
                )}
            </div>
            <div className='flex gap-3 flex-col md:flex-row'>
                <div className="">
                    <label className="text-sm font-bold text-gray-700 dark:text-white mb-1 block">Role*</label>
                    <CustomDropdown
                        label="Select Role"
                        options={roles}
                        value={formData.role}
                        onChange={(value) => handleChange("role", value)}
                        extra={`w-full`}
                    />
                </div>

                <div className="">
                    <label className="text-sm font-bold text-gray-700 dark:text-white mb-1 block">Status*</label>
                    <CustomDropdown
                        label="Select Status"
                        options={statuses}
                        value={formData.status}
                        onChange={(value) => handleChange("status", value)}
                        extra={`w-full`}
                    />
                </div>
            </div>
            {token ? '' : <>
                <p className='text-sm font-small text-gray-600 mb-3'>*Admin Needs To Activtae Your Account Before Login</p>
            </>}
            <button
                onClick={handleSubmit}
                className="mt-4 w-full py-2 bg-brand-500 text-white rounded-md hover:bg-brand-700"
            >
                {token ? <>
                {userId ? 'Update User' : 'Create User'}                
                </> : <>
                CREATE ACCOUNT
                </>}
            </button>
        </Card>
    );
};

export default UserCreation;
